<template>
  <div id="app">
    <router-view/>

    <FloatContent />
  </div>
</template>
<script>
import FloatContent from '@/components/FloatContent/index.vue'

export default {
  components: {
    FloatContent
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>
<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
}
* {
margin: 0;
padding: 0;
}
ul {
  list-style: none;
}
a {
    text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue